
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/a5ad98cef7fb0013710af7dda5c63c4b/1bdc9ff35c3391c1d6e2109623d91117.png"
                alt="ViaEducacaoCursos"
                className="h-10 w-10"
              />
              <span className="text-xl font-bold text-white">ViaEducacaoCursos</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Transformando a educação através da inteligência artificial e metodologias práticas.
            </p>
          </div>

          <div>
            <h3 className="text-base font-semibold text-white mb-4">Cursos</h3>
            <ul className="space-y-3">
              <li><Link to="/cursos" className="text-sm hover:text-orange-400 transition-colors">Formação Continuada</Link></li>
              <li><Link to="/cursos" className="text-sm hover:text-orange-400 transition-colors">IA na Prática</Link></li>
              <li><Link to="/cursos" className="text-sm hover:text-orange-400 transition-colors">Metodologias Ativas</Link></li>
              <li><Link to="/cursos" className="text-sm hover:text-orange-400 transition-colors">Certificações</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold text-white mb-4">Serviços</h3>
            <ul className="space-y-3">
              <li><Link to="/mentoria" className="text-sm hover:text-orange-400 transition-colors">Mentoria Individual</Link></li>
              <li><Link to="/consultoria" className="text-sm hover:text-orange-400 transition-colors">Consultoria Escolar</Link></li>
              <li><Link to="/cursos" className="text-sm hover:text-orange-400 transition-colors">Workshops</Link></li>
              <li><Link to="/sobre" className="text-sm hover:text-orange-400 transition-colors">Palestras</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-base font-semibold text-white mb-4">Recursos</h3>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm hover:text-orange-400 transition-colors">Blog</a></li>
              <li><a href="#" className="text-sm hover:text-orange-400 transition-colors">Materiais Gratuitos</a></li>
              <li><a href="#" className="text-sm hover:text-orange-400 transition-colors">Webinars</a></li>
              <li><a href="#" className="text-sm hover:text-orange-400 transition-colors">Comunidade</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col items-center gap-5 md:flex-row md:justify-between">

            {/* Ícones sociais */}
            <div className="flex items-center gap-6 order-1 md:order-2">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors" aria-label="LinkedIn">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="https://www.instagram.com/viaeducacaocursos/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors" aria-label="Instagram">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="https://www.youtube.com/@ViaEduca%C3%A7%C3%A3oCursos" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors" aria-label="YouTube">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="https://www.facebook.com/viaeducacao" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-400 transition-colors" aria-label="Facebook">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>

            {/* Copyright + links legais */}
            <div className="flex flex-col items-center gap-3 order-2 md:order-1 md:items-start">
              <p className="text-sm text-gray-400 text-center md:text-left">
                © {currentYear} ViaEducacaoCursos. Todos os direitos reservados.
              </p>
              <div className="flex flex-wrap justify-center md:justify-start items-center gap-x-4 gap-y-2">
                <Link to="/politica-de-privacidade" className="text-sm text-gray-400 hover:text-orange-400 transition-colors whitespace-nowrap">
                  Política de Privacidade
                </Link>
                <span className="text-gray-600 hidden sm:inline">·</span>
                <Link to="/termos-de-uso" className="text-sm text-gray-400 hover:text-orange-400 transition-colors whitespace-nowrap">
                  Termos de Uso
                </Link>
                <span className="text-gray-600 hidden sm:inline">·</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-orange-400 transition-colors whitespace-nowrap">
                  Powered by Readdy
                </a>
              </div>
            </div>
          </div>

          <div className="mt-5 text-center">
            <p className="text-xs text-gray-500 leading-relaxed">
              ViaEducacaoCursos é uma marca de{' '}
              <strong className="text-gray-400">Vrc Programas Treinamentos e Cursos Educacionais Ltda</strong>{' '}
              — CNPJ 62.934.863/0001-93
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
